export default {
    login: '/session/login',
    logout: '/session/logOut',
    checkLoginSession: '/session/checkLoginSession',
    getSession: '/session/getSession',
    getPlayerBalance: '/user/getPlayerBalance',
    getBetsHistory: '/user/getBetsHistory',
    getPlayerTransactions: '/user/getPlayerTransactions',
    checkDepositEligibility: '#',
    checkWithdrawalEligibility: '/user/checkWithdrawalEligibility',
    createOnlineDeposit: '/user/createOnlineDeposit',
    createOnlineWithdrawal: '/user/createOnlineWithdrawal',
    createOnlineTransaction: '#',
    createBankTransferWithdrawal: '#',
    cancelWithdrawal: '/user/cancelWithdrawal',
    getPlayerSettings: '/user/getPlayerSettings',
    updatePlayerSettings: '/user/setPlayerSettings',
    uploadDocumentVerification: '/user/uploadDocumentVerification',
    uploadReactivationDocument: '/user/uploadReactivationDocument',
    getClubs: '/user/getClubs',
    registrationSecondStep: '/user/registrationSecondStep',
    forgotPassword: '/user/forgotPassword',
    updatePassword: '/user/updatePassword',
    changeForgottenPassword: '/user/changeForgottenPassword',
    getAllGames: '/rest/SBWeb.Models.Casino/getAllGames',
    getLiveCasinoGames: {
        desktop: '/rest/SBWeb.Models.Casino/getLiveCasinoGamesDesktop',
        mobile: '/rest/SBWeb.Models.Casino/getLiveCasinoGamesMobile',
    },
    getPlayerShortcutGames: '/casino/getPlayerShortcutGames',
    togglePlayerShortcutGames: '/casino/togglePlayerShortcutGame',
    gamingPlay: '/api/v1/gaming/play',
    getPopupMessages: '/user/getPopupMessages',
    launchGame: '/casino/launchGame',
    getBanners: '/rest/SBWeb.Models.Banners/getBanners',
    getPlayerDetails: '/user/getPlayerDetailsV2',
    messageAction: '/user/messageAction',
    returnSiteParams: '/rest/SBWeb.Models.Session/returnSiteParams',
    getCountries: '#',
    update: '/user/update',
    updatePrivacyConsent: '/user/updatePrivacyConsent',
    validateRegistrationData: '/user/validateRegistrationData',
    apiVersion: '/user',
    getGameHistory: '/user/getGameHistory',
    getVirtualGamesHistory: '/user/getVirtualGamesHistory',
    getJackpotData: '/rest/SBWeb.Models.Offer/getJackpotData',
    getJackpotDataEgyptQuest: '/rest/SBWeb.Models.Offer/getJackpotDataEgyptQuest',
    resendSmsCode: '/user/resendSmsCode',
    validateSmsCode: '/user/validateSmsCode',
    sendActivationEmail: 'user/sendActivationEmail',
    getPlayerLimits: '/user/getPlayerLimits',
    setPlayerLimits: '/user/setPlayerLimits',
    cancelPlayerLimit: '/user/cancelPlayerLimit',
    timeOutPlayer: '/user/TimeOutPlayer',
    selfExcludePlayer: '/user/selfExcludePlayer',
    closeAccount: '/user/CloseAccount',
    closeAccountMfa: '#',
    getPlayerBonuses: '/bonus/getPlayerBonuses',
    getListOfPromotions: '/bonus/getListOfPromotions',
    getListOfPlayerPromotions: '/bonus/getListOfPlayerPromotions',
    getAvailableBonuses: '/bonus/getAvailableBonuses',
    getLottoFavorites: 'user/getLotoFavorites',
    setLottoFavorites: 'user/setLotoFavorites',
    shopWithdrawal: '/user/shopWithdrawal',
    bonusOptIn: '/bonus/bonusOptIn',
    bonusOptOut: '/bonus/bonusOptOut',
    casinoPrefix: '/casino',
    walletBreakdown: '#',
    fetchBetGeniusStreamData: '/user/fetchBetGeniusStreamData',
    getBetEligibility: '/user/getBetEligibility',
    updateCustomParams: '/user/updateCustomParams',
    identityData: '#',
    sendPlayerLoginNotification: '/user/sendPlayerLoginNotification',
    loginPlayerAlternativeChannel: '/user/loginPlayerAlternativeChannel',
    getLoginData: '/session/getLoginData',
    getWelcomeBonusEligibility: '#',
    playerLicencePreferences: '#',
    getIdentityProviderUrl: '/user/initKYCWithMojeId',
    getKYCMojeIdResponse: '/user/getKYCMojeIdResponse',
    getVerificationUrl: '/user/verificationUrl',
    setLocale: '#',
    createQuickDeposit: '#',
    getRegulatorData: '#',
    promotionOptIn: '/bonus/promotionOptIn',
    getLoginHistory: '#',
    getKycDetails: '/user/getKycDetails',
    bankRegistrationUrl: '#',
    verifyMfaCode: '/user/verifyMfaCode',
    sendMfaCode: '/user/sendMfaCode',
    getSessionStats: '#',
    completeKycReverification: '/user/completeKycReverification',
};

export const serviceProps = {
    launchDarklyUserKeyVariable: 'externalUUID',
} as const;
